import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ContainerYardForm } from '@/components/forms/ContainerYardForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function ContainerYardCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/container-yards/yard-list')
  }

  const handleCancel = () => {
    navigate('/container-yards/yard-list')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Container Yard</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new container yard with details
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <ContainerYardForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
